import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6808f96e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modalWrap" }
const _hoisted_2 = { class: "table products" }
const _hoisted_3 = { class: "table__title" }
const _hoisted_4 = { class: "tableHead" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tableHead__cell" }, "ID", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tableHead__cell" }, "UID", -1))
const _hoisted_7 = { class: "tableHead__cell" }
const _hoisted_8 = { class: "tableHead__cell" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tableHead__cell" }, null, -1))
const _hoisted_10 = { class: "tableItem__cell" }
const _hoisted_11 = { class: "tableItem__cell" }
const _hoisted_12 = { class: "tableItem__cell" }
const _hoisted_13 = { class: "tableItem__cell current" }
const _hoisted_14 = { class: "table transactions" }
const _hoisted_15 = { class: "table__title" }
const _hoisted_16 = { class: "transactionsTableHead" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "transactionsTableHead__cell" }, "ID", -1))
const _hoisted_18 = { class: "transactionsTableHead__cell" }
const _hoisted_19 = { class: "transactionsTableHead__cell" }
const _hoisted_20 = { class: "transactionsTableHead__cell" }
const _hoisted_21 = { class: "transactionsTableHead__cell" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "transactionsTableHead__cell" }, null, -1))
const _hoisted_23 = { class: "transactionsTableHead__cell" }
const _hoisted_24 = { class: "transactionsTableHead__cell" }
const _hoisted_25 = { class: "transactionsTableItem__cell" }
const _hoisted_26 = { class: "transactionsTableItem__cell" }
const _hoisted_27 = { class: "transactionsTableItem__cell" }
const _hoisted_28 = { class: "transactionsTableItem__cell" }
const _hoisted_29 = { class: "transactionsTableItem__cell current" }
const _hoisted_30 = { class: "transactionsTableItem__cell" }
const _hoisted_31 = { class: "transactionsTableItem__cell" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WithLoader = _resolveComponent("WithLoader")!
  const _component_CommonModal = _resolveComponent("CommonModal")!

  return (_openBlock(), _createBlock(_component_CommonModal, {
    name: _ctx.modalName,
    isModalPurchases: true,
    title: `${_ctx.$t('Purchase')} ${_ctx.productsInfo && _ctx.productsInfo[0]?.marketplace_id}`
  }, {
    default: _withCtx(() => [
      _createVNode(_component_WithLoader, { state: _ctx.state }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('Products')), 1),
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("Name")), 1),
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("Price")), 1),
                _hoisted_9
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productsInfo, (item, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "tableItem"
                }, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(item.id), 1),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(item.uid), 1),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(item.name), 1),
                  _createElementVNode("div", {
                    class: _normalizeClass(['tableItem__cell', { 'greenText': item.price > 0 }])
                  }, _toDisplayString(item.price), 3),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.currencies[item.currency_id]), 1)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('Transactions')), 1),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t("Date")), 1),
                _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("Time, UTC")), 1),
                _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("Description")), 1),
                _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t("Sum")), 1),
                _hoisted_22,
                _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t("Type")), 1),
                _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t("Status")), 1)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transactionsInfo, (item, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "transactionsTableItem"
                }, [
                  _createElementVNode("div", _hoisted_25, _toDisplayString(item.id), 1),
                  _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.dateDay(+item.date)), 1),
                  _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.getTime(+item.date + 1)), 1),
                  _createElementVNode("div", _hoisted_28, _toDisplayString(item.description), 1),
                  _createElementVNode("div", {
                    class: _normalizeClass(['transactionsTableItem__cell', { 'greenText': item.sum > 0 }])
                  }, _toDisplayString(item.sum), 3),
                  _createElementVNode("span", _hoisted_29, _toDisplayString(item.currency.symbol), 1),
                  _createElementVNode("div", _hoisted_30, _toDisplayString(item.marketplace), 1),
                  _createElementVNode("div", _hoisted_31, _toDisplayString(item.status_name), 1)
                ]))
              }), 128))
            ])
          ])
        ]),
        _: 1
      }, 8, ["state"])
    ]),
    _: 1
  }, 8, ["name", "title"]))
}